module.exports = __webpack_public_path__ + "img/login-logo@2x.838d9903.png";